export default __webpack_public_path__ + "static/media/Component_Window.979c9c89.gif";